import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Clock, MapPin, Instagram } from 'lucide-react';
import { businessInfo } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">Genuine Fencers</h3>
            <p className="footer-description">
              Premium glass fencing and balustrade solutions in Sydney. Quality workmanship, professional service.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services">Glass Pool Fencing</Link></li>
              <li><Link to="/services">Glass Balustrades</Link></li>
              <li><Link to="/services">Aluminum Fencing & Louvers</Link></li>
              <li><Link to="/services">Custom Glass Panels</Link></li>
              <li><Link to="/services">Supply & Installation</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-heading">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <a href="tel:+61414443454">{businessInfo.phone}</a>
              </li>
              <li>
                <Mail size={16} />
                <a href={`mailto:${businessInfo.email}`}>{businessInfo.email}</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>{businessInfo.location}</span>
              </li>
              <li>
                <Clock size={16} />
                <span>{businessInfo.hours.weekdays}</span>
              </li>
              <li>
                <Instagram size={16} />
                <a href="https://www.instagram.com/genuine_fencers?igsh=MTJubnBzZ2NzZjFlMw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer">
                  @genuine_fencers
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} Genuine Fencers. All rights reserved.</p>
            <div className="footer-social">
              <a 
                href="https://www.instagram.com/genuine_fencers?igsh=MTJubnBzZ2NzZjFlMw%3D%3D&utm_source=qr" 
                target="_blank" 
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
